export const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const SHOPIFY_DOMAIN = "https://shopify.cleed.ai/";
